namespace GeniuzPOS.Points {
    export interface PrPointRedeemItemForm {
        PluCode: Serenity.LookupEditor;
        NoOfPoint: Serenity.DecimalEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        CreateBy: Serenity.StringEditor;
        CreateDate: Serenity.DateEditor;
        UpdateBy: Serenity.StringEditor;
        LastUpdate: Serenity.DateEditor;
    }

    export class PrPointRedeemItemForm extends Serenity.PrefixedContext {
        static formKey = 'Points.PrPointRedeemItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PrPointRedeemItemForm.init)  {
                PrPointRedeemItemForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;
                var w3 = s.StringEditor;

                Q.initFormType(PrPointRedeemItemForm, [
                    'PluCode', w0,
                    'NoOfPoint', w1,
                    'StartDate', w2,
                    'EndDate', w2,
                    'CreateBy', w3,
                    'CreateDate', w2,
                    'UpdateBy', w3,
                    'LastUpdate', w2
                ]);
            }
        }
    }
}
